<div class="my-3">
  <div class="row align-items-center border-bottom">
    <div class="col-9">
      <h4 class="card-title mb-3" style="color: rgb(5, 78, 128) !important">
        {{ section.label }}
      </h4>
    </div>
    <div class="col-3 text-end"></div>
  </div>
  <div
    class="card shadow-none border"
    style="border-color: rgb(214, 234, 185) !important">
    <div class="card-body">
      <div class="row d-flex flex-wrap">
        <ng-container appForms></ng-container>
        <div
          *ngIf="
            section.name === 'FAMILY_RESPONSIBLE_PARTY' &&
            familyRelativesAddded.length === 4
          ">
          <span ngbTooltip="Max 4 Family Memebers">
            <button
              disabled
              class="btn btn-soft-success mt-3 ms-3 col-1"
              type="submit">
              Add
            </button>
          </span>
        </div>

        <div
          *ngIf="
            section.name === 'FAMILY_RESPONSIBLE_PARTY' &&
            familyRelativesAddded.length < 4
          ">
          <button
            class="btn btn-soft-success mt-3 ms-3 col-1"
            type="submit"
            (click)="addFamilyRelative()">
            Add
          </button>
        </div>

        <div *ngIf="section.name === 'FAMILY_RESPONSIBLE_PARTY'">
          <div class="row mt-3 gx-4">
            <div class="col-12" *ngIf="familyRelativesAddded.length > 0">
              <p style="color: #20d6a0">Added</p>

              <div
                class="d-flex my-4 gap-3 w-100"
                *ngFor="let ans of familyRelativesAddded; let i = index">
                <div
                  class="rounded-3 p-3 flex-fill"
                  style="background-color: #ecf2f8">
                  <span style="color: #054e80; font-weight: 600">Name</span>
                  <p class="mb-0">{{ ans.relative_name.value }}</p>
                </div>
                <div
                  class="rounded-3 p-3 flex-fill"
                  style="background-color: #ecf2f8">
                  <span style="color: #054e80; font-weight: 600"
                    >Relationship</span
                  >
                  <p class="mb-0">{{ ans.relative_relationship.value }}</p>
                </div>
                <div
                  class="rounded-3 p-3 flex-fill"
                  style="background-color: #ecf2f8"
                  *ngIf="ans.relative_notes">
                  <span style="color: #054e80; font-weight: 600">Notes</span>
                  <p class="mb-0">
                    {{
                      ans.relative_notes.value === 'null'
                        ? ''
                        : ans.relative_notes.value
                    }}
                  </p>
                </div>
                <div
                  class="rounded-3 p-3 flex-fill"
                  style="background-color: #ecf2f8"
                  *ngIf="ans.relative_local">
                  <span style="color: #054e80; font-weight: 600">Local</span>
                  <p class="mb-0">
                    {{ ans.relative_local.value === 'true' ? 'yes' : 'No' }}
                  </p>
                </div>
                <div
                  class="rounded-3 p-3 flex-fill"
                  style="background-color: #ecf2f8; max-width: 250px"
                  *ngIf="ans.relative_tags">
                  <span style="color: #054e80; font-weight: 600">Tags</span>
                  <div class="p-2">
                    <div class="row">
                      <div
                        class="col-12 rounded-2 mb-2"
                        style="border: 1px solid #20d6a0"
                        *ngFor="let elem of ans.relative_tags.value">
                        <div class="p-1">
                          <i
                            class="bx bx-check-shield"
                            style="color: #20d6a0"></i>
                          <span>{{ elem }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  (click)="deleteFamilyRelative(i)"
                  class="btn btn-sm btn-soft-danger waves-effect rounded-circle align-self-center flex-shrink-1">
                  <i class="bx bx-trash-alt"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
